import { useEffect, useState } from 'react'
import moment from 'moment';
import { useProfileDetails } from '../../profile-details/api/profileapi';
import { useModalContext } from '../../../contexts/ModalContext';
import { Footer } from '../../../components/footer';
import { useNavigate } from 'react-router-dom';
import ClaimConfirmModal from '../../modals/claimConfirm';
import AirdropSlotReward from './SlotAirDropRewars';

const AirdropTab = () => {
    const {  userDetails
    } = useModalContext()
    const { data: profileData } = useProfileDetails()

    const [isExpired, setIsExpired] = useState(false);
    const navigate = useNavigate()

    useEffect(() => {
        if (userDetails?.data?.airdropExpiryTime) {
            const expiryTime = new Date(userDetails?.data?.airdropExpiryTime);

            const currentTime = new Date();

            // Check if the expiry time has passed
            if (currentTime >= expiryTime) {
                setIsExpired(true);
            } else {
                setIsExpired(false);
            }
        }
    }, [userDetails]);

    const [claimSuccessModal, setClaimSuccessModal] = useState(false);

    return (
        <div>
            <div className="mainContent">
                <div className="pageContent def-py-30">

                    <div className='container'>
                        <div className="appPagetitle d-flex g-10 align-items-center">
                            <button className='btn btnBack' onClick={() => navigate('/redeem-wallet')}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <span>Airdrop</span>
                        </div>
                        <div className='row'>
                            <div className="col-lg-12">
                                <div className="appcard mb-4 px-0 pb-2 cardbg">
                                    <div className="cardHeader border-bottom-0 px-4 pb-0">
                                        <div className='px-4 '>
                                            <div className='airdropTabBx mb-5'>
                                                <div className="row justify-content-between">
                                                    <div className="col-lg-auto col-md-6 mb-3 mb-lg-0">
                                                        <div>
                                                            <div className="fs-14 fw-400 text-white-60">Airdrop Amount</div>
                                                            <div className='fs-15 fw-500'>{profileData?.airdropRewardAmount} <span className='text-white-60'>TPL</span></div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-auto col-md-6 mb-3 mb-lg-0">
                                                        <div>
                                                            <div className="fs-14 fw-400 text-white-60">Start Date & Time</div>
                                                            <div className='fs-15 fw-500'>{moment(userDetails?.data?.airdropActivatedTime).format("DD/MM/YYYY | hh:mm A")}</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-auto col-md-6 mb-3 mb-md-0">
                                                        <div>
                                                            <div className="fs-14 fw-400 text-white-60">End Date & Time</div>
                                                            <div className='fs-15 fw-500'>{moment(userDetails?.data?.airdropExpiryTime).format("DD/MM/YYYY | hh:mm A")} </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        profileData?.airdropClaimStatus ?
                                                            <div className="col-lg-auto col-md-6">
                                                                <button className='btn btnClaim text-success' disabled={profileData?.airdropClaimStatus}  >Claimed</button>
                                                            </div> :
                                                            <div className="col-lg-auto col-md-6">
                                                                <button className='btn btnClaim' disabled={!isExpired || sessionStorage.getItem('role') === 'adminView'} onClick={() => setClaimSuccessModal(!claimSuccessModal)
                                                                    } >Claim</button>
                                                            </div>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <AirdropSlotReward />
                <Footer />
            </div>
            <ClaimConfirmModal modalOpen={claimSuccessModal} modalClose={() => setClaimSuccessModal(!claimSuccessModal)} reward={profileData?.airdropRewardAmount} />

        </div>
    )
}


export default AirdropTab;